import React from 'react';

import { useStockNotifications } from '@jetshop/core/hooks/Subscriptions/useStockNotifications';
import { useIntl } from '@jetshop/intl';
import { styled } from 'linaria/react';

import { theme } from '../../Theme';
import UIButton from '../../ui/Button';

import { ReactComponent as CloseIcon } from '../../../svg/Close.svg';

const Button = styled(UIButton)`
   background: ${theme.colors.black};
   width: 100%;
   margin-bottom: 20px;
   border: 1px solid black;
`;

const Modal = styled.div`
   position: absolute;
   top: -12px;
   left: -1%;
   width: 102%;

   border: 1px solid var(--gray-2);
   padding: var(--spacing-m);
   background: white;

   header {
      position: relative;

      h3 {
         margin-bottom: var(--text-line-height);
      }

      .close-button {
         position: absolute;
         top: 0;
         right: 0;
         background: transparent;
      }
   }

   input {
      font-size: var(--text-size);
      font-family: var(--text-font);
      padding: var(--text-size);
      padding-left: 0;
      width: 100%;
      border: 0;
      border-bottom: 1px solid var(--text);
      margin-bottom: var(--text-size);

      &:focus {
         outline: none;
         border-bottom: 1px solid var(--gray-2);
      }
   }

   button {
      text-transform: uppercase;
      margin-bottom: 0;
   }

   .failed {
      color: var(--red);
      margin-bottom: var(--text-size);
   }
`;

const Wrapper = styled('div')`
   position: relative;
   width: 100%;
`;

function NotifyWhenBack({ articleNumber }) {
   const {
      toggle,
      submit,
      inputProps,
      active,
      inactive,
      submitting,
      submitted,
      failed,
   } = useStockNotifications({ articleNumber });

   const t = useIntl();
   const disabled = inputProps.value.length === 0 || submitting;

   return (
      <Wrapper>
         <Button onClick={toggle} data-testid="notify-when-back-button">
            {t('Notify me when back in stock')}
         </Button>

         {failed && (
            <Modal>
               <p className="failed">{t('Oops, something went wrong.')}</p>
               <Button onClick={toggle} data-testid="notify-when-back-button">
                  {t('Please try again')}
               </Button>
            </Modal>
         )}

         {active && (
            <Modal>
               <header>
                  <h3>{t('Produkten är slutsåld')}</h3>
                  <p>
                     {t('We will notify you when the item is back in stock.')}
                  </p>
                  <button className="close-button" onClick={() => toggle()}>
                     <CloseIcon />
                  </button>
               </header>
               <form onSubmit={submit} disabled={disabled}>
                  <input
                     type="email"
                     id="stock-notifications"
                     data-testid="notify-when-back-input"
                     aria-label={t('Epostadress')}
                     placeholder={t('Epostadress')}
                     required
                     {...inputProps}
                  />
                  <Button data-testid="notify-when-back-ok" disabled={disabled}>
                     {t('Meddela mig')}
                  </Button>
               </form>
            </Modal>
         )}

         {submitted && (
            <Modal>
               <p data-testid="notify-when-back-success">
                  {t('Tack! Vi skickar ett epost när varan är åter i lager')}
               </p>
            </Modal>
         )}
      </Wrapper>
   );
}

export default NotifyWhenBack;
